import { useTranslation } from "react-i18next";
import type { BlobItem as BlobItemType } from "@azure/storage-blob";
import { formatDate, formatFileSize } from "@/utils/formatters";
import { BlobIndexStatus } from "./BlobIndexStatus";

interface BlobInfoProps {
  blob: BlobItemType;
}

export function BlobInfo({ blob }: BlobInfoProps) {
  const { t } = useTranslation();

  return (
    <div className="flex-1 min-w-0">
      <div className="flex items-center">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <p className="text-sm font-medium text-gray-900 truncate">
              {blob.name}
            </p>
            <BlobIndexStatus blobName={blob.name} />
          </div>
          <div className="mt-1 flex items-center text-sm text-gray-500">
            <span>
              {formatFileSize(blob.properties.contentLength)}
            </span>
            <span className="mx-2">•</span>
            <span>
              {t("knowledgeBase.modified", { date: formatDate(blob.properties.lastModified) })}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
